(() => {
  function formatGuideMeasurement(value, unit, type = '') {
    const raw = String(value ?? '').trim();
    if (!raw || type === 'text') return raw;
    const match = raw.match(/^(\d+(?:\.\d+)?)\s*(?:cm)?\s*(?:[-–—]\s*(\d+(?:\.\d+)?)\s*(?:cm)?)?$/i);
    if (!match) return raw;
    const convert = number => unit === 'in'
      ? String(Math.round(Number(number) / 2.54 * 2) / 2)
      : number;
    return `${convert(match[1])}${match[2] ? `–${convert(match[2])}` : ''} ${unit === 'in' ? 'in' : 'cm'}`;
  }

  if (customElements.get('dharco-product-size-guide')) return;
  customElements.define('dharco-product-size-guide', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.modal = this.querySelector('dialog');
      this.content = this.querySelector('[data-content]');
      this.disableUnitConversion = this.content
        .querySelector('[data-test-guide]')
        ?.dataset.disableUnitConversion === 'true';

      this.querySelector('[data-open]').addEventListener('click', () => {
        if (!this.modal.open) this.modal.showModal();
      });
      this.querySelector('[data-close]').addEventListener('click', () => this.modal.close());
      this.modal.addEventListener('click', event => {
        if (event.target === this.modal) this.modal.close();
      });
      this.content.addEventListener('click', event => {
        if (this.disableUnitConversion) return;
        const button = event.target.closest('[data-guide-unit]');
        if (!button || !this.content.contains(button)) return;
        this.setUnit(button.dataset.guideUnit);
      });
      this.setUnit('in');
    }

    disconnectedCallback() {
      if (this.modal?.open) this.modal.close();
    }

    setUnit(unit) {
      this.content.querySelectorAll('[data-guide-unit]').forEach(item => {
        item.setAttribute('aria-pressed', String(item.dataset.guideUnit === unit));
      });
      this.content.querySelectorAll('[data-cm]').forEach(cell => {
        cell.textContent = formatGuideMeasurement(cell.dataset.cm, unit, cell.dataset.columnType);
      });
      this.content.querySelectorAll('[data-guide-column-label]').forEach(heading => {
        const label = heading.dataset.guideColumnLabel;
        heading.textContent = heading.dataset.columnType === 'text'
          ? label
          : label.replace(/\s*\(cm\)\s*$|\s+cm\s*$/i, unit === 'in' ? ' (IN)' : ' (CM)');
      });
    }
  });
})();
